"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _Modal = _interopRequireDefault(require("../Modal/Modal"));

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 16px 24px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 0px 16px 20px 16px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-self: flex-end;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledIconButton = (0, _styledComponents.default)(_IconButton.default)(_templateObject());
var DialogTitle = (0, _styledComponents.default)(_core.DialogTitle)(_templateObject2());
var DialogContent = (0, _styledComponents.default)(_core.DialogContent)(_templateObject3());

var ConfirmModal = function ConfirmModal(_ref) {
  var title = _ref.title,
      children = _ref.children,
      action = _ref.action,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ["title", "children", "action", "onClose"]);

  return _react.default.createElement(_Modal.default, Object.assign({
    onClose: onClose
  }, props), _react.default.createElement(_Grid.default, {
    container: true
  }, _react.default.createElement(_Grid.default, {
    item: true,
    xs: true
  }, _react.default.createElement(DialogTitle, {
    disableTypography: true
  }, _react.default.createElement(_Typography.default, {
    variant: "h6",
    gutterBottom: true
  }, title))), _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement(StyledIconButton, {
    size: "small",
    onClick: onClose
  }, _react.default.createElement(_Icon.default, {
    name: "close"
  })))), _react.default.createElement(DialogContent, null, children), action.length >= 2 ? _react.default.createElement(_core.Divider, null) : '', _react.default.createElement(_core.DialogActions, null, action));
};

ConfirmModal.defaultProps = {
  open: false,
  title: '',
  children: '',
  action: ''
};
var _default = ConfirmModal;
exports.default = _default;